__webpack_require__.p = "https://amanda.pazinatoti.com.br/";